import type { SalesTaxLineV2 } from "@credit-acceptance/step6-bff-client";
import { useTranslation } from "react-i18next";

import { formatCurrency } from "../../../../lib/money";
import type { AuditTableColumn } from "../../../audit/AuditTable";
import SummaryTableModal from "../../components/SummaryTableModal";
import { EMPTY_VALUE, formatOptional } from "./financialFormat";

interface SalesTaxModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lines: SalesTaxLineV2[];
  total?: number;
}

// Read-only per-item sales tax breakdown, opened from the "Sales Tax" link
function SalesTaxModal({ open, onOpenChange, lines, total }: SalesTaxModalProperties) {
  const { t } = useTranslation();

  const columns: Array<AuditTableColumn<SalesTaxLineV2>> = [
    { key: "name", header: t("financial.modalColumns.name"), render: (line) => line.name || EMPTY_VALUE },
    {
      key: "taxableAmount",
      header: t("financial.modalColumns.taxableAmount"),
      render: (line) => formatOptional(line.taxableAmount, formatCurrency),
    },
    {
      key: "taxMethod",
      header: t("financial.modalColumns.taxMethod"),
      render: (line) => line.taxMethod || EMPTY_VALUE,
    },
    {
      key: "taxAmount",
      header: t("financial.modalColumns.taxAmount"),
      render: (line) => formatOptional(line.taxAmount, formatCurrency),
    },
  ];

  return (
    <SummaryTableModal
      open={open}
      onOpenChange={onOpenChange}
      title={t("financial.salesTaxModal.title")}
      description={t("financial.salesTaxModal.description")}
      caption={t("financial.salesTaxModal.caption")}
      summaryLines={[{ label: t("financial.salesTaxModal.total"), value: formatOptional(total, formatCurrency) }]}
      columns={columns}
      rows={lines}
    />
  );
}

export default SalesTaxModal;
